/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/currency';
import './time';
import '../common/time';
import './data';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "timecards": {
        "nested": {
          "WorkweekConfiguration": {
            "fields": {
              "startOfWeek": {
                "type": ".squareup.timecards.WorkweekConfiguration.DayOfWeek",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": "MONDAY"
                }
              },
              "startOfDayOffsetMinutes": {
                "type": "uint32",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": 0
                }
              }
            },
            "nested": {
              "DayOfWeek": {
                "values": {
                  "MONDAY": 1,
                  "TUESDAY": 2,
                  "WEDNESDAY": 3,
                  "THURSDAY": 4,
                  "FRIDAY": 5,
                  "SATURDAY": 6,
                  "SUNDAY": 7
                }
              }
            }
          },
          "CalculationTotal": {
            "fields": {
              "regularSeconds": {
                "type": "uint32",
                "id": 1,
                "rule": "optional",
                "options": {
                  "default": 0
                }
              },
              "overtimeSeconds": {
                "type": "uint32",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": 0
                }
              },
              "doubletimeSeconds": {
                "type": "uint32",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": 0
                }
              },
              "secondsWorkedForPayState": {
                "type": ".squareup.timecards.CalculationTotal.MapEntry",
                "id": 4,
                "rule": "repeated"
              },
              "totalPaidSeconds": {
                "type": "uint32",
                "id": 5,
                "rule": "optional"
              }
            },
            "nested": {
              "PayState": {
                "values": {
                  "REGULAR": 1,
                  "REGULAR_PAID_BREAK": 2,
                  "REGULAR_UNPAID_BREAK": 3,
                  "OVERTIME": 4,
                  "OVERTIME_PAID_BREAK": 5,
                  "OVERTIME_UNPAID_BREAK": 6,
                  "DOUBLETIME": 7,
                  "DOUBLETIME_PAID_BREAK": 8,
                  "DOUBLETIME_UNPAID_BREAK": 9
                }
              },
              "MapEntry": {
                "fields": {
                  "payState": {
                    "type": ".squareup.timecards.CalculationTotal.PayState",
                    "id": 1,
                    "rule": "optional"
                  },
                  "seconds": {
                    "type": "uint32",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": 0
                    }
                  }
                }
              }
            }
          },
          "OvertimeRule": {
            "fields": {
              "reason": {
                "type": ".squareup.timecards.OvertimeRule.Reason",
                "id": 1,
                "rule": "optional"
              },
              "triggerSeconds": {
                "type": "uint32",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Reason": {
                "values": {
                  "WEEKLY_OVERTIME": 1,
                  "DAILY_OVERTIME": 2,
                  "DAILY_DOUBLETIME": 3,
                  "SEVENTH_DAY_OVERTIME": 4,
                  "SEVENTH_DAY_DOUBLETIME": 5
                }
              }
            }
          },
          "LaborCostTotal": {
            "fields": {
              "regularLaborMoney": {
                "type": ".squareup.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "overtimeLaborMoney": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "doubletimeLaborMoney": {
                "type": ".squareup.common.Money",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "LaborCalculation": {
            "fields": {
              "jobTitle": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "paidSeconds": {
                "type": "uint64",
                "id": 2,
                "rule": "optional"
              },
              "baseHourlyRate": {
                "type": ".squareup.common.Money",
                "id": 3,
                "rule": "optional"
              },
              "premiumHourlyRate": {
                "type": ".squareup.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "laborMoney": {
                "type": ".squareup.common.Money",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "LaborCalculationSummary": {
            "fields": {
              "localDateTimeRange": {
                "type": ".squareup.timecards.LocalDateTimeRange",
                "id": 1,
                "rule": "optional"
              },
              "averageWage": {
                "type": ".squareup.common.Money",
                "id": 2,
                "rule": "optional"
              },
              "totalPaidSeconds": {
                "type": "uint64",
                "id": 3,
                "rule": "optional"
              },
              "totalLaborMoney": {
                "type": ".squareup.common.Money",
                "id": 4,
                "rule": "optional"
              },
              "regularLaborCalculations": {
                "type": ".squareup.timecards.LaborCalculation",
                "id": 5,
                "rule": "repeated"
              },
              "overtimeLaborCalculations": {
                "type": ".squareup.timecards.LaborCalculation",
                "id": 6,
                "rule": "repeated"
              },
              "doubletimeLaborCalculations": {
                "type": ".squareup.timecards.LaborCalculation",
                "id": 7,
                "rule": "repeated"
              }
            }
          },
          "TimeWindowCalculation": {
            "fields": {
              "timeInterval": {
                "type": ".squareup.common.time.DateTimeInterval",
                "id": 1,
                "rule": "optional"
              },
              "employeeToken": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "calculationTotal": {
                "type": ".squareup.timecards.CalculationTotal",
                "id": 3,
                "rule": "optional"
              },
              "weekCalculations": {
                "type": ".squareup.timecards.TimeWindowCalculation.WeekCalculation",
                "id": 4,
                "rule": "repeated"
              },
              "workweekConfiguration": {
                "type": ".squareup.timecards.WorkweekConfiguration",
                "id": 5,
                "rule": "optional"
              },
              "wellAlignedWithWeek": {
                "type": "bool",
                "id": 6,
                "rule": "optional"
              }
            },
            "nested": {
              "WeekCalculation": {
                "fields": {
                  "timeInterval": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 1,
                    "rule": "optional"
                  },
                  "calculationTotal": {
                    "type": ".squareup.timecards.CalculationTotal",
                    "id": 2,
                    "rule": "optional"
                  },
                  "dayCalculations": {
                    "type": ".squareup.timecards.TimeWindowCalculation.DayCalculation",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "DayCalculation": {
                "fields": {
                  "timeInterval": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 1,
                    "rule": "optional"
                  },
                  "calculationTotal": {
                    "type": ".squareup.timecards.CalculationTotal",
                    "id": 2,
                    "rule": "optional"
                  },
                  "segmentCalculation": {
                    "type": ".squareup.timecards.TimeWindowCalculation.SegmentCalculation",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "segmentGroup": {
                    "type": ".squareup.timecards.TimeWindowCalculation.SegmentGroup",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "SegmentGroup": {
                "fields": {
                  "segmentCalculation": {
                    "type": ".squareup.timecards.TimeWindowCalculation.SegmentCalculation",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "timecard": {
                    "type": ".squareup.timecards.Timecard",
                    "id": 3,
                    "rule": "optional"
                  },
                  "timecardAndBreaks": {
                    "type": ".squareup.timecards.TimecardAndBreaks",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "SegmentCalculation": {
                "fields": {
                  "timeInterval": {
                    "type": ".squareup.common.time.DateTimeInterval",
                    "id": 1,
                    "rule": "optional"
                  },
                  "calculationTotal": {
                    "type": ".squareup.timecards.CalculationTotal",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          },
          "PaidBreakOverageConversionSummary": {
            "fields": {
              "convertedDuration": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "totalLaborCostSaved": {
                "type": ".squareup.common.Money",
                "id": 2,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.timecards?.nested?.WorkweekConfiguration && !$root.nested?.squareup?.nested?.timecards?.nested?.WorkweekConfiguration?.nested?.DayOfWeek && !$root.nested?.squareup?.nested?.timecards?.nested?.CalculationTotal && !$root.nested?.squareup?.nested?.timecards?.nested?.CalculationTotal?.nested?.PayState && !$root.nested?.squareup?.nested?.timecards?.nested?.CalculationTotal?.nested?.MapEntry && !$root.nested?.squareup?.nested?.timecards?.nested?.OvertimeRule && !$root.nested?.squareup?.nested?.timecards?.nested?.OvertimeRule?.nested?.Reason && !$root.nested?.squareup?.nested?.timecards?.nested?.LaborCostTotal && !$root.nested?.squareup?.nested?.timecards?.nested?.LaborCalculation && !$root.nested?.squareup?.nested?.timecards?.nested?.LaborCalculationSummary && !$root.nested?.squareup?.nested?.timecards?.nested?.TimeWindowCalculation && !$root.nested?.squareup?.nested?.timecards?.nested?.TimeWindowCalculation?.nested?.WeekCalculation && !$root.nested?.squareup?.nested?.timecards?.nested?.TimeWindowCalculation?.nested?.DayCalculation && !$root.nested?.squareup?.nested?.timecards?.nested?.TimeWindowCalculation?.nested?.SegmentGroup && !$root.nested?.squareup?.nested?.timecards?.nested?.TimeWindowCalculation?.nested?.SegmentCalculation && !$root.nested?.squareup?.nested?.timecards?.nested?.PaidBreakOverageConversionSummary) {
  $root.addJSON(jsonData);
}

/**
 * In timecards land, merchants are able to set when the beginning of their workweek is, and when
 * the start of the day is.
 *
 * For example, it may make sense for a bar to have their start of the week be a Friday and
 * their start of day be 2:00am.
 *
 * When requesting a calculation, keep in mind the configuration, or else results may not be
 * aligned correctly.
 *
 * Note that configurations are per-unit, not per-merchant.
 *
 * SOURCE WorkweekConfiguration @ squareup/timecards/time_calculation.proto at 26:1
 */
export const WorkweekConfiguration = $root.lookupType('squareup.timecards.WorkweekConfiguration');
fixType(WorkweekConfiguration);
Builder.createAndAttachToType(WorkweekConfiguration);
/**
 * Note that this mimics Java's <code>DayOfWeek</code> class
 *
 * SOURCE DayOfWeek @ squareup/timecards/time_calculation.proto at 28:3
 */
WorkweekConfiguration.DayOfWeek = $root.lookupEnum('squareup.timecards.WorkweekConfiguration.DayOfWeek').values;
/**
 * Combination of regular, overtime and doubletime seconds worked, including paid and unpaid breaks.
 *
 * SOURCE CalculationTotal @ squareup/timecards/time_calculation.proto at 55:1
 */
export const CalculationTotal = $root.lookupType('squareup.timecards.CalculationTotal');
fixType(CalculationTotal);
Builder.createAndAttachToType(CalculationTotal);
/**
 * SOURCE PayState @ squareup/timecards/time_calculation.proto at 65:3
 */
CalculationTotal.PayState = $root.lookupEnum('squareup.timecards.CalculationTotal.PayState').values;
/**
 * SOURCE MapEntry @ squareup/timecards/time_calculation.proto at 77:3
 */
CalculationTotal.MapEntry = $root.lookupType('squareup.timecards.CalculationTotal.MapEntry');
fixType(CalculationTotal.MapEntry);
Builder.createAndAttachToType(CalculationTotal.MapEntry);
/**
 * SOURCE OvertimeRule @ squareup/timecards/time_calculation.proto at 87:1
 */
export const OvertimeRule = $root.lookupType('squareup.timecards.OvertimeRule');
fixType(OvertimeRule, {
  reason: {
    required: true
  },
  triggerSeconds: {
    required: true
  }
});
Builder.createAndAttachToType(OvertimeRule);
/**
 * SOURCE Reason @ squareup/timecards/time_calculation.proto at 92:3
 */
OvertimeRule.Reason = $root.lookupEnum('squareup.timecards.OvertimeRule.Reason').values;
/**
 * SOURCE LaborCostTotal @ squareup/timecards/time_calculation.proto at 101:1
 */
export const LaborCostTotal = $root.lookupType('squareup.timecards.LaborCostTotal');
fixType(LaborCostTotal);
Builder.createAndAttachToType(LaborCostTotal);
/**
 * LaborCalculation specifies the exact computations that were used to determine pay.
 * Each calculation should refer to a single *type* of pay (e.g. regular time vs overtime vs doubletime).
 *
 * paid_seconds * (base_hourly_rate + premium_hourly_rate) = labor_money
 *
 * SOURCE LaborCalculation @ squareup/timecards/time_calculation.proto at 113:1
 */
export const LaborCalculation = $root.lookupType('squareup.timecards.LaborCalculation');
fixType(LaborCalculation, {
  paidSeconds: {
    required: true
  },
  baseHourlyRate: {
    required: true
  },
  premiumHourlyRate: {
    required: true
  },
  laborMoney: {
    required: true
  }
});
Builder.createAndAttachToType(LaborCalculation);
/**
 * Details of how labor cost was calculated, within a given workweek.
 * Should be scoped to a single employee, although this proto does not require providing
 * detailed information about *which* employee the pay is calculated for.
 * May represent complex scenarios, including multiple wages and overtime/doubletime.
 *
 * SOURCE LaborCalculationSummary @ squareup/timecards/time_calculation.proto at 127:1
 */
export const LaborCalculationSummary = $root.lookupType('squareup.timecards.LaborCalculationSummary');
fixType(LaborCalculationSummary, {
  localDateTimeRange: {
    required: true
  },
  totalPaidSeconds: {
    required: true
  },
  totalLaborMoney: {
    required: true
  }
});
Builder.createAndAttachToType(LaborCalculationSummary);
/**
 * An overtime calculation with an arbitrary time window, split into 1-week intervals. If you
 * use the Timecards service to generate a TimeWindowCalculation, the results will be as accruate
 * as possible.
 *
 * See SimpleTimeWorkedCalculationRequest More on calculation correctness
 *
 * SOURCE TimeWindowCalculation @ squareup/timecards/time_calculation.proto at 153:1
 */
export const TimeWindowCalculation = $root.lookupType('squareup.timecards.TimeWindowCalculation');
fixType(TimeWindowCalculation, {
  timeInterval: {
    required: true
  },
  employeeToken: {
    notEmpty: true
  },
  calculationTotal: {
    required: true
  },
  workweekConfiguration: {
    required: true
  }
});
Builder.createAndAttachToType(TimeWindowCalculation);
/**
 * An overtime calculation aligned to a week (7 days). Note that the beginnning and end of a week is
 * relative, based upon a WorkweekConfiguration.
 *
 * SOURCE WeekCalculation @ squareup/timecards/time_calculation.proto at 177:3
 */
TimeWindowCalculation.WeekCalculation = $root.lookupType('squareup.timecards.TimeWindowCalculation.WeekCalculation');
fixType(TimeWindowCalculation.WeekCalculation, {
  timeInterval: {
    required: true
  },
  calculationTotal: {
    required: true
  }
});
Builder.createAndAttachToType(TimeWindowCalculation.WeekCalculation);
/**
 * An overtime calculation that is 1 day long.
 *
 * <strong>A day can span 23, 24 or 25 hours!</strong> Daylight savings may result in a day that
 * is not 24 hours.
 *
 * SOURCE DayCalculation @ squareup/timecards/time_calculation.proto at 194:3
 */
TimeWindowCalculation.DayCalculation = $root.lookupType('squareup.timecards.TimeWindowCalculation.DayCalculation');
fixType(TimeWindowCalculation.DayCalculation, {
  timeInterval: {
    required: true
  },
  calculationTotal: {
    required: true
  }
});
Builder.createAndAttachToType(TimeWindowCalculation.DayCalculation);
/**
 * A segment group consists of a single timecard that changed states (i.e. regular time -> overtime)
 * and is broken down into segments
 *
 * SOURCE SegmentGroup @ squareup/timecards/time_calculation.proto at 207:3
 */
TimeWindowCalculation.SegmentGroup = $root.lookupType('squareup.timecards.TimeWindowCalculation.SegmentGroup');
fixType(TimeWindowCalculation.SegmentGroup, {
  timecardAndBreaks: {
    required: true
  }
});
Builder.createAndAttachToType(TimeWindowCalculation.SegmentGroup);
/**
 * An arbitrary segment. Coresponds to a period of time with a single PayState
 *
 * SOURCE SegmentCalculation @ squareup/timecards/time_calculation.proto at 216:3
 */
TimeWindowCalculation.SegmentCalculation = $root.lookupType('squareup.timecards.TimeWindowCalculation.SegmentCalculation');
fixType(TimeWindowCalculation.SegmentCalculation, {
  timeInterval: {
    required: true
  },
  calculationTotal: {
    required: true
  }
});
Builder.createAndAttachToType(TimeWindowCalculation.SegmentCalculation);
/**
 * SOURCE PaidBreakOverageConversionSummary @ squareup/timecards/time_calculation.proto at 223:1
 */
export const PaidBreakOverageConversionSummary = $root.lookupType('squareup.timecards.PaidBreakOverageConversionSummary');
fixType(PaidBreakOverageConversionSummary, {
  convertedDuration: {
    notEmpty: true
  },
  totalLaborCostSaved: {
    required: true
  }
});
Builder.createAndAttachToType(PaidBreakOverageConversionSummary);